import axios from "axios";
import { ApiKey, BaseUrl } from "../global";

export const saveBanner = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/PortalBanner/SaveBanner', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const UpdateBanner = async (id, isActive, data, source) => {
    try {
        const rs = await axios.post(BaseUrl + `api/PortalBanner/UpdateBanner?id=${id}&isActive=${isActive}`, data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const getActiveBanner = async (source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/PortalBanner/GetActiveBanner', {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const getBanners = async (source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/PortalBanner/GetBanners', {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const GetImagesForView = async (id, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/PortalBanner/GetImagesForView?id=' + id , {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}